const messages = {
  title: "Marknadssamtycken",
  required: "Obligatorisk",
  answered: "✓ Besvarad",
  read: "Läst",
  notRead: "Ej läst",
  alreadyAnswered: "Redan besvarad",
  requiredQuestionsMustBeAccepted:
    "{count} obligatoriska frågor måste accepteras",
  pleaseAnswerQuestions: "Besvara följande frågor:",
  iAccept: "Jag accepterar",
  scrollToUnlock: "Scrolla till slutet för att låsa upp",
  fieldRequired: "Detta fält är obligatoriskt",
  scrollToContinue: "↓ Scrolla till slutet för att fortsätta",
  saving: "Sparar...",
  saveConsents: "Spara samtycken",
  allRequiredAccepted: "✓ Alla obligatoriska frågor accepterade",
  requiredConsentsCompleted:
    "{completed}/{total} obligatoriska samtycken slutförda",
  selectConsentToView:
    "Välj ett samtycke i listan för att visa innehållet",
  readAllContentFirst: "Läs allt innehåll först: {names}",
  acceptAllRequiredIn: "Acceptera alla obligatoriska frågor i: {names}",
  acceptAllBeforeSaving:
    "Acceptera alla obligatoriska frågor innan du sparar.",
  failedToSave: "Det gick inte att spara samtycken. Försök igen.",
  errorSaving: "Ett fel uppstod när samtycken skulle sparas. Försök igen.",
  failedToLoad: "Det gick inte att ladda samtycken. Uppdatera sidan.",
  viewPdf: "Visa PDF",
  requiredConsentTitle: "Obligatoriskt samtycke",
  acceptAndContinue: "Acceptera och fortsätt",
};

export default {
  messages,
};
